import { combineReducers } from "redux";
import backButtonDestination from "./backButtonDestination/backButtonDestination";
import currentlyOpenModal from "./currentlyOpenModal/currentlyOpenModal";
import hotspotEditorReducer, {
  clearLocations,
  locationChangeIntent,
  locationSetIntent,
  setActiveAlgorithm,
  setCurrentFrameIndex,
  setCurrentStep,
} from "./hotspotEditor/hotspotEditorReducers";
import spinInfoReducer from "./spinInfo/spinInfoReducers";
import spinURL from "./spinURL/spinURL";
import folderURL from "./folderURL/folderURL";
import hotspotImport from "./hotspotImport/hotspotImport";
import staticImageId from "./staticImageId/staticImageId";
import ui, { releaseActiveHotspotDrag } from "./ui/ui";
import boxVariant from "./boxVariant/boxVariant";
import pointerVariant from "./pointerVariant/pointerVariant";
import undoable, { groupByActionTypes, includeAction } from "redux-undo";

const undoableActionTypes = [
  locationChangeIntent,
  locationSetIntent,
  releaseActiveHotspotDrag,
  setActiveAlgorithm,
  setCurrentFrameIndex,
].map((actionCreator) => actionCreator().type);

const undoClearHistoryActionTypes = [setCurrentStep, clearLocations].map(
  (actionCreator) => actionCreator().type
);

const undoGroupByActionTypes = [setCurrentFrameIndex].map(
  (actionCreator) => actionCreator().type
);

const rootReducer = combineReducers({
  spinURL,
  folderURL,
  editor: undoable(hotspotEditorReducer, {
    filter: includeAction(undoableActionTypes),
    clearHistoryType: undoClearHistoryActionTypes,
    groupBy: groupByActionTypes(undoGroupByActionTypes),
    neverSkipReducer: true,
  }),
  spinInfo: spinInfoReducer,
  currentlyOpenModal,
  backButtonDestination,
  hotspotImport,
  staticImageId,
  ui,
  boxVariant,
  pointerVariant,
});

export default rootReducer;
